module.exports = __webpack_public_path__ + "img/mobile_banner_navigation.b9b8fa3d.png";